//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import basisopleidingen from '~/graphql/queries/basisopleidingen.gql';
import vervolgopleidingen from '~/graphql/queries/vervolgopleidingen.gql';

export default {
  name: 'OpleidingOverzicht',
  apollo: {
    basisopleidingen: {
      query: basisopleidingen,
    },
    vervolgopleidingen: {
      query: vervolgopleidingen,
    },
  },
  data: () => ({
    basisopleidingen: [],
    vervolgopleidingen: [],
  }),
  computed: {
    basisopleidingenComputed() {
      return this.basisopleidingen.map((m) => { return {value: m.id, label: m.title}; });
    },
    vervolgopleidingenComputed() {
      return this.vervolgopleidingen.map((m) => { return {value: m.id, label: m.title}; });
    },
    diplomaTypes() {
      return [
        'application/pdf',
        'image/jpeg',
        'image/png',
      ].join(',');
    },
    diplomaValidation() {
      return `bail|required|mime:${this.diplomaTypes}`;
    },
    nonRequiredDiplomaValidation() {
      return `bail|mime:${this.diplomaTypes}`;
    },
  },
};
